export default "__VITE_ASSET__pR8cLdSK__"